// extracted by mini-css-extract-plugin
export default {"containerForm":"LoginPasswordReset_containerForm__yr7bq","ponto":"LoginPasswordReset_ponto__pScHp","form":"LoginPasswordReset_form__fEhRW","modal":"LoginPasswordReset_modal__ecJPK"};